var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.$store.getters['global/isLoaded'])?_c('Loader'):_c('router-view')
}
var staticRenderFns = []

export { render, staticRenderFns }